import axios from "axios";
import Cookies from "js-cookie";

const AxiosAgent = axios.create({
    baseURL: import.meta.env.VITE_API_BASE_URL_AGENT_CHAT,
    timeout: 100000,
});

// Utility to get and store the token
const getToken = async (): Promise<string | null> => {
    // const tokenKey =
    //   process.env.NEXT_PUBLIC_KINDE_ACCESS_TOKEN || 'kinde_access_token';

    const token = Cookies.get(import.meta.env.VITE_KINDE_ACCESS_TOKEN || "kinde_access_token");
    // let token = localStorage.getItem(tokenKey);

    return token || null;
};

// Add Axios request interceptor
AxiosAgent.interceptors.request.use(
    async (config) => {
        try {
            const token = await getToken();
            if (token) {
                // Ensure headers are properly set
                config.headers = config.headers || {};
                config.headers.set("Authorization", `Bearer ${token}`);
            }
        } catch (error) {
            console.error("Error setting authorization header:", error);
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default AxiosAgent;
